import qs from 'qs';
import { kazooUrl } from '../config/settings/worktango.settings';

interface QueryStringOptions {
  ignoreQueryPrefix?: boolean;
  comma?: boolean;
  [key: string]: any;
}

const parseQueryString = (str: string, options: QueryStringOptions = {}): any => {
  const optionsWithDefaults: QueryStringOptions = {
    ignoreQueryPrefix: true,
    comma: true,
    ...options,
  };

  return qs.parse(str, optionsWithDefaults);
};

const queryStringify = (obj: any, options: QueryStringOptions = {}): string => {
  const optionsWithDefaults: QueryStringOptions = {
    arrayFormat: 'comma',
    encode: false,
    ...options,
  };

  // @ts-expect-error TS(2345): Argument of type '{ arrayFormat: string; encode: b... Remove this comment to see the full error message
  return qs.stringify(obj, optionsWithDefaults);
};

const changeSubdomain = (url: string, subdomain: string, protocol = 'https'): string => {
  const originalUrl = new URL(url);
  const urlParts = originalUrl.hostname.split('.');
  const domain =
    urlParts.length > 2
      ? `${urlParts[1]}.${urlParts[2]}` // remove subdomain
      : originalUrl.hostname; // e.g., 'localhost', or if Url already has no subdomain
  const urlWithSubdomain = `${protocol}://${subdomain}.${domain}`;

  return urlWithSubdomain;
};

const replaceQueryParam = (search: string, name: string, value: any): string => {
  const { [name]: paramName, ...remainingParams } = parseQueryString(search);

  const newParams = queryStringify({
    ...remainingParams,
    [name]: value,
  });

  return newParams;
};

const parseAttributeValueFilters = (search: string, label = 'filters'): any => {
  const queryParams = parseQueryString(search);
  const attributeValues = queryParams[label] || {};

  // Ensure each attributeValue is an array, even if only 1 element.
  Object.keys(attributeValues).forEach((attrId) => {
    if (!Array.isArray(attributeValues[attrId])) {
      attributeValues[attrId] = [attributeValues[attrId]];
    }
  });

  return attributeValues;
};

const KAZOO_URL_ENV_TEMPLATE_STRING = '{workspace}';

const createKazooBaseUrl = (workspace: string): string | undefined => {
  return kazooUrl?.replace(KAZOO_URL_ENV_TEMPLATE_STRING, workspace);
};

const isSafeRelativePath = (url: string): boolean => {
  return url.startsWith('/') && !url.startsWith('//') && !url.includes('://');
};

export const urls = {
  parseQueryString,
  queryStringify,
  changeSubdomain,
  replaceQueryParam,
  parseAttributeValueFilters,
  createKazooBaseUrl,
  isSafeRelativePath,
};
